export const name = "FORMAT_TIME";
export const summary = `Formats a \`TIME\` value according to the specified format string.`;
export const reference = `
## FORMAT_TIME

Formats a \`TIME\` value according to the specified format string.

\`\`\`
FORMAT_TIME(format_string, time_expr)
\`\`\`

### Description

Formats a \`TIME\` value according to the specified format string.


### Definitions

- \`format_string\`: A \`STRING\` value that contains the format elements to use with \`time_expr\`.
- \`time_expr\`: A \`TIME\` value that represents the time to format.


### Return Data Type

\`STRING\`


### Example



\`\`\`
SELECT FORMAT_TIME("%R", TIME "15:30:00") as formatted_time;

/*----------------*
 | formatted_time |
 +----------------+
 | 15:30 |
 *----------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/time_functions
`;
